import { useMemo } from 'react';
import { ZodIssueCode, type ZodIssue } from 'zod';

import type { SchemaErrorEntry } from 'utils/contentful/entry-schema';

import { useIsError } from './SchemaError.hooks';
import * as S from './SchemaError.style';

const flattenAndFilterIssues = (issues: ZodIssue[]) =>
  (issues || [])
    .map((issue) => {
      if (issue.code === ZodIssueCode.invalid_union) {
        return issue.unionErrors
          .filter(
            (error) =>
              !error.issues.some(
                (issue) =>
                  issue.path[issue.path.length - 1] === '_type' &&
                  issue.code === ZodIssueCode.invalid_literal,
              ),
          )
          .flatMap(({ issues }) => issues);
      }

      return [issue];
    })
    .flat();

export const SchemaError = ({ error, inputType }: SchemaErrorEntry) => {
  const issues = useMemo(
    () => flattenAndFilterIssues(error.issues),
    [error.issues],
  );

  useIsError();

  return (
    <S.Container>
      Schema validation error(s) in <S.InlinePre>{inputType}</S.InlinePre>:
      <S.UnorderedList>
        {issues.map(({ path, message }, index) => (
          <li key={index}>
            <S.InlinePre>{path.join('.')}</S.InlinePre> &#8594; "{message}"
          </li>
        ))}
      </S.UnorderedList>
    </S.Container>
  );
};

export default SchemaError;
